/** @format */

import { ChangeEvent, ChangeEventHandler, useEffect, useState } from "react";

import { Card, Button, FormLabel } from "react-bootstrap";

import * as APIModels from "../../../../models";
import {
    OrganizationService,
    ClientService,
} from "../../../../services/ClientService";
import background from "../../../../assets/images/multiple-arrow.png";

export default function FirmMapper({
    organization,
    organizationId,
}: {
    organization: APIModels.Organization;
    organizationId: string;
}) {
    const [updatedOrganization, setUpdatedOrganization] =
        useState(organization);
    const [dbFirms, setDBFirms] = useState([] as APIModels.Firm[]);
    const [updatedFirms, setUpdatedFirms] = useState([] as APIModels.Firm[]);
    const [dbSearchList, setDbSearchList] = useState([] as APIModels.Firm[]);
    const [updatedSearchList, setUpdatedSearchList] = useState(
        [] as APIModels.Firm[]
    );
    const [firmsToAdd, setFirmsToAdd] = useState([] as APIModels.Firm[]);
    const [load, setLoad] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [searching, setSearching] = useState(false);
    const [success, setSuccess] = useState(false);
    const [searchDB, setSearchDB] = useState("" as string);
    const [searchOrgFirms, setSearchOrgFirms] = useState("" as string);

    useEffect(() => {
        if (load) {
            ClientService.getFirms().then(
                (resp) => {
                    if (resp.successful && resp.data) {
                        setDBFirms([...resp.data]);
                        setDbSearchList(resp.data as APIModels.Attorney[]);
                    } else {
                        setErrorMessage("An API Error Occured");
                    }
                },
                (err) => {
                    setErrorMessage(err);
                }
            );

            OrganizationService.getFirmsFromOrg({
                id: organizationId,
            }).then(
                (resp) => {
                    if (resp.successful && resp.data) {
                        setUpdatedFirms([...resp.data]);
                        //	setFilteredFirms([...resp.data]);
                        setUpdatedSearchList(resp.data as APIModels.Attorney[]);
                    } else {
                        setErrorMessage("An API Error Occured");
                    }
                },
                (err) => {
                    setErrorMessage(err);
                }
            );
            setLoad(false);
        }
    }, []);

    const updateSelectedFirms = (event: ChangeEvent<HTMLSelectElement>) => {
        const value = Array.from(
            event.target.selectedOptions,
            (option) => option.value
        );

        const temp = [...dbFirms];
        const stage = [] as APIModels.Firm[];
        value.forEach((newFirm) => {
            temp.forEach((oldFirm) => {
                if (newFirm === oldFirm.id) {
                    stage.push(oldFirm);
                }
            });
        });
        const tempUpdatedFirms = [...updatedFirms];
        stage.forEach((stageFirm) => {
            if (
                updatedFirms.find((firm) => firm.id === stageFirm.id) ===
                undefined
            ) {
                tempUpdatedFirms.push(stageFirm);
            }
        });
        console.log({ "updated firms": tempUpdatedFirms });
        // Update the updatedFirms to the tempUpdatedFirmsNoDuplicates
        setUpdatedFirms(tempUpdatedFirms);
        setFirmsToAdd([]);
    };

    const removeSelectedFirms = (event: ChangeEvent<HTMLSelectElement>) => {
        const value = Array.from(
            event.currentTarget.selectedOptions,
            (option) => option.value
        );

        const tempUpdatedFirms = [...updatedFirms];
        value.forEach((valAtt) => {
            if (
                tempUpdatedFirms.find((att) => att.id === valAtt) != undefined
            ) {
                const index = tempUpdatedFirms.indexOf(
                    updatedFirms.find((att) => att.id === valAtt)!,
                    0
                );
                tempUpdatedFirms.splice(index, 1);
            }
        });
        setUpdatedFirms([...tempUpdatedFirms]);
    };

    useEffect(() => {
        setSearching(false);
    }, [success]);

    const mapSelectedFirms = () => {
        setSearching(true);
        setErrorMessage("");
        OrganizationService.firms({
            id: organization.id ?? "",
            body: updatedFirms,
        }).then(
            (resp) => {
                if (!resp.successful || !resp.data) {
                    setErrorMessage("An API Error Occured");
                } else {
                    setErrorMessage("Successfully Updated Organization Firms");
                }
            },
            (error) => {
                setErrorMessage("An API Error Occured");
            }
        );
        setSuccess(!success);
        //setSearching(false);
    };

    const RenderOptions = (
        searchable: string,
        options: APIModels.Firm[],
        update: (event: React.ChangeEvent<HTMLSelectElement>) => void
    ): JSX.Element => {
        if (searchable !== "") {
            const temp = options.filter((v, i) => {
                if (
                    v.name!.toLowerCase().includes(searchable.toLowerCase()) ==
                    true
                ) {
                    return v;
                }
            });
            return (
                <select
                    name="country"
                    className="multi-select"
                    multiple={true}
                    id="my_multi_select3"
                    onChange={(event) => update(event)}
                    style={{
                        width: "300px",
                        height: "200px",
                    }}
                >
                    {temp.map((firm) => (
                        <option value={firm?.id}>{firm?.name}</option>
                    ))}
                </select>
            );
        } else {
            return (
                <select
                    name="country"
                    className="multi-select"
                    multiple={true}
                    id="my_multi_select3"
                    onChange={(event) => update(event)}
                    style={{
                        width: "300px",
                        height: "200px",
                    }}
                >
                    {" "}
                    {options.map((firm) => (
                        <option value={firm?.id}>{firm?.name}</option>
                    ))}{" "}
                </select>
            );
        }
    };

    return (
        <>
            <Card>
                <Card.Body
                    style={{
                        backgroundImage: `url(${background}) `,
                        backgroundRepeat: "no-repeat",
                        backgroundPositionX: "50%",
                        backgroundPositionY: "50%",
                    }}
                >
                    <h4 className="mb-3 bg-light p-2">Organization Firms</h4>
                    <div className="row text-center">
                        <div className="col-6 text-center">
                            <div
                                className="col-10"
                                style={{ marginLeft: "17px" }}
                            >
                                <label
                                    htmlFor="my_multi_select3"
                                    className="form-label"
                                >
                                    All Firms
                                </label>
                                <input
                                    id="my_multi_select3"
                                    type="text"
                                    className="form-control search-input"
                                    autoComplete="off"
                                    placeholder="search..."
                                    onChange={(event) =>
                                        setSearchDB(event.target.value)
                                    }
                                    style={{ width: "300px" }}
                                ></input>{" "}
                            </div>
                            {RenderOptions(
                                searchDB,
                                dbFirms,
                                updateSelectedFirms
                            )}
                        </div>
                        <div className="col-6">
                            <div
                                className="col-10"
                                style={{ marginLeft: "17px" }}
                            >
                                <label
                                    htmlFor="my_multi_select3"
                                    className="form-label"
                                >
                                    Organization's Firms
                                </label>
                                <input
                                    id="my_multi_select3"
                                    type="text"
                                    className="form-control search-input"
                                    autoComplete="off"
                                    placeholder="search..."
                                    onChange={(event) =>
                                        setSearchOrgFirms(event.target.value)
                                    }
                                    style={{ width: "300px" }}
                                ></input>{" "}
                            </div>
                            {RenderOptions(
                                searchOrgFirms,
                                updatedFirms,
                                removeSelectedFirms
                            )}
                        </div>
                    </div>
                    <div className="row text-end mt-3">
                        <div>
                            {" "}
                            {searching ? (
                                <button
                                    className="btn btn-primary"
                                    type="button"
                                    disabled={true}
                                >
                                    <span
                                        className="spinner-border spinner-border-sm me-1"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Saving...
                                </button>
                            ) : (
                                <button
                                    className="btn btn-primary"
                                    type="button"
                                    onClick={mapSelectedFirms}
                                >
                                    Save
                                </button>
                            )}
                        </div>
                        <div>{errorMessage}</div>
                    </div>
                </Card.Body>
            </Card>
        </>
    );
}
